import { Component }                          from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpErrorResponse }                  from '@angular/common/http';

import { catchError } from 'rxjs/operators';

import { ToastrService } from 'ngx-toastr';

import { emailValidatorRegex }               from '@utils/validators/email-validator-regex';
import { defaultPhoneMask }                  from '@utils/masks/phone-mask';
import { phoneValidatorRegex }               from '@utils/validators/phone-validator-regex';
import { UF, ufOptions }                     from '@models/utils/uf';
import { SchoolType, schoolTypeOptions }     from '@models/utils/school-type';
import { RoleInSchool, roleInSchoolOptions } from '@models/utils/role-in-school';
import { Mask }                              from '@models/utils/mask';

import { ErrorService }      from '@utils/error/error.service';
import { ApiContactService } from '@services/api-contact.service';


@Component({
  selector:    'red-for-schools',
  templateUrl: './for-schools.component.html',
  styleUrls:   [ './for-schools.component.scss' ]
})
export class ForSchoolsComponent {

  public pilotForm:           FormGroup;
  public ufOptions:           UF[];
  public schoolTypeOptions:   SchoolType[];
  public roleInSchoolOptions: RoleInSchool[];
  public phoneMask:           Mask;

  constructor(
    private formBuilder:    FormBuilder,
    private toastr:         ToastrService,
    private errorService:   ErrorService,
    private contactService: ApiContactService
  ) {
    this.ufOptions           = ufOptions;
    this.schoolTypeOptions   = schoolTypeOptions;
    this.roleInSchoolOptions = roleInSchoolOptions;
    this.phoneMask           = defaultPhoneMask;

    const emailValidators = [ Validators.required, Validators.pattern(emailValidatorRegex) ],
          phoneValidators = [ Validators.required, Validators.pattern(phoneValidatorRegex) ];

    this.pilotForm = this.formBuilder.group(
      {
        nome:       this.formBuilder.control('', [ Validators.required ]),
        email:      this.formBuilder.control('', [ ...emailValidators ]),
        telefone:   this.formBuilder.control('', [ ...phoneValidators ]),
        cargo:      this.formBuilder.control('', [ Validators.required ]),
        escola:     this.formBuilder.control('', [ Validators.required ]),
        tipoEscola: this.formBuilder.control('', [ Validators.required ]),
        uf:         this.formBuilder.control('', [ Validators.required ]),
        municipio:  this.formBuilder.control('', [ Validators.required ])
      }
    );

    this.pilotForm.get('uf').setValue('SP');
  }

  public submitPilotForm() {
    if (this.pilotForm.invalid) return;

    this.pilotForm.disable();

    const handleError = (error: HttpErrorResponse) => {
      this.pilotForm.enable();
      return this.errorService.handleFormError(error);
    };

    this.contactService.postPilotContact(this.pilotForm.value).pipe(
      catchError(handleError)
    ).subscribe(() => {
      this.toastr.success(
        'Nossa equipe entrará em contato assim que possível.',
        'Sua solicitação foi enviada',
        { timeOut: 10000 }
      );

      // this.sendRdContact(this.pilotForm.value);
      this.pilotForm.enable();
    });
  }

  /*private sendRdContact(
    formValue: {[ key: string ]: any }
  ) {
    this.rdStationService.postConversionEvent(
      {
        conversion_identifier:            'piloto',
        email:                            formValue['email'],
        name:                             formValue['nome'],
        personal_phone:                   formValue['telefone'],
        cf_cargo_ocupacao_do_lead:        formValue['cargo'],
        cf_escola:                        formValue['escola'],
        cf_tipo_de_instituicao_de_ensino: formValue['tipoEscola'],
        state:                            formValue['uf'],
        city:                             formValue['municipio']
      }
    ).subscribe();
  }*/

}
